import { EngineLiveIcon } from "design_system_radar/icons/EngineLiveIcon";
import { RadarLoader } from "design_system_radar/loaders/RadarLoader";

import useReconciliation from "@/hooks/useReconciliation";

export default function ReconciliationWorkingV2() {
  const { working } = useReconciliation();

  if (!working) return null;

  return (
    <div className="fixed inset-0 z-10000 flex items-center justify-center bg-[#0F172A]/80 backdrop-blur-md transition-all duration-300">
      <div className="relative flex flex-col items-center max-w-120 w-full bg-[#171821] p-12 rounded-[40px] border border-white/5 shadow-[0_0_50px_0_rgba(0,0,0,0.5)] animate-in fade-in zoom-in duration-300">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-[#1C1D26] border border-white/10 mb-8">
          <EngineLiveIcon size={40} className="text-radar-120" animated />
        </div>

        <h2 className="text-white text-2xl font-bold mb-4 text-center">
          Conciliación en proceso
        </h2>

        <p className="text-radar-120 text-center text-sm leading-relaxed mb-10 px-4">
          Se está procesando tu conciliación. Por favor espera hasta que se
          finalice el proceso.
        </p>

        <div className="flex justify-center">
          <RadarLoader />
        </div>
      </div>
    </div>
  );
}
